module.exports = __webpack_public_path__ + "static/media/RonitPic.a4cc5089.png";